__turbopack_context__.v({
  "root": "Skill-module__Wfh_Lq__root",
});
